import { fromJS } from "immutable";
import TaskList from "~/records/record.task_list.jsx";
import TaskListMap from "~/records/record.task_list_map.jsx";
import * as actionTypes from "~/store/action_types";

export const task_list = (state = new TaskList(), action) => {
  switch (action.type) {
    case actionTypes.ADD_TASK_LIST_LOADING:
      return new TaskList({
        ...state.toObject(),
      });
    case actionTypes.MOVE_TASK_LIST_TO_TRASH_LOADING:
      return new TaskList({
        ...state.toObject(),
        _pending: true,
      });
    case actionTypes.COMPLETE_TASK_LIST_LOADING:
      return new TaskList({
        ...state.toObject(),
        _pending: true,
        completed_on: action.timestamp,
        is_completed: true,
      });
    case actionTypes.MOVE_TASK_LIST_TO_TRASH_SUCCESS:
      return new TaskList({
        ...state.toObject(),
        is_trashed: true,
        _pending: false,
      });
    case actionTypes.MOVE_TASK_LIST_TO_TRASH_ERROR:
    case actionTypes.COMPLETE_TASK_LIST_ERROR:
      return new TaskList({
        ...state.toObject(),
        _pending: false,
      });
    case actionTypes.REORDER_TASK_LIST_LOADING:
    case actionTypes.REORDER_TASK_LIST_SUCCESS:
      return new TaskList({
        ...state.toObject(),
        position: action.taskListsOrder.indexOf(state.id) + 1,
      });
    case actionTypes.INSERT_TASK_LIST_SUCCESS:
      return new TaskList({
        ...state.toObject(),
        position: action.response.result.order.indexOf(state.id) + 1,
      });
    case actionTypes.REOPEN_TASK_LIST_LOADING:
    case actionTypes.REOPEN_TASK_LIST_SUCCESS: {
      return new TaskList({
        ...state.toObject(),
        is_completed: false,
      });
    }
    case actionTypes.TASK_LIST_MOVE_TO_TRASH_FROM_EVENT_STREAM:
    case actionTypes.TASK_LIST_COMPLETED_FROM_EVENT_STREAM:
    case actionTypes.TASK_LIST_REOPENED_FROM_EVENT_STREAM:
    case actionTypes.TASK_LIST_RESTORED_FROM_TRASH_FROM_EVENT_STREAM:
    case actionTypes.ADD_TASK_LIST_FROM_EVENT_STREAM:
    case actionTypes.UPDATE_TASK_LIST_FROM_EVENT_STREAM:
    case actionTypes.TASK_LIST_MOVED_TO_PROJECT_FROM_EVENT_STREAM: {
      const { response = {} } = action;
      const { entities = {}, result: taskListId } = response;
      const { task_lists = {} } = entities;

      const data = task_lists[`${taskListId}`];

      if (data) {
        return new TaskList(
          fromJS({
            ...state.toObject(),
            ...data,
          })
        );
      }

      return state;
    }
    case actionTypes.FETCH_TEAM_TASKS_SUCCESS: {
      const { response = {} } = action;
      const { result = {} } = response;
      const { related = {} } = result;
      const { TaskList: TaskLists = {} } = related;

      const data = TaskLists[`${state.get(`id`)}`];

      if (data) {
        return new TaskList(
          fromJS({
            ...state.toObject(),
            ...data,
          })
        );
      }

      return state;
    }
    case actionTypes.INSERT_TASK_LIST_FROM_EVENT_STREAM: {
      return new TaskList({
        ...state.toObject(),
        position: action.order.indexOf(state.id) + 1,
      });
    }
    case actionTypes.TASK_LIST_REORDERED_FROM_EVENT_STREAM: {
      const { id, position } = action;

      if (id) {
        return new TaskList({
          ...state.toObject(),
          id,
          position,
        });
      }

      return state;
    }
    case actionTypes.PROJECT_MOVE_TO_TRASH_FROM_EVENT_STREAM_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result: id } = response;

      if (state.get("project_id") !== id) {
        return state;
      }

      if (state.get("is_trashed")) {
        return new TaskList({
          ...state.toObject(),
          original_is_trashed: true,
        });
      }

      const { projects = {} } = entities;
      const { trashed_on = null, trashed_by_id = 0 } = projects[id];

      return new TaskList({
        ...state.toObject(),
        is_trashed: true,
        trashed_on,
        trashed_by_id,
      });
    }
    default:
      return state;
  }
};

const mergeEntities = (state, newTaskLists) => {
  return state.merge(newTaskLists.map((t) => new TaskList(t)));
};

const task_lists = (state = new TaskListMap(), action) => {
  switch (action.type) {
    case actionTypes.ADD_TASK_LIST_LOADING:
    case actionTypes.ADD_TASK_LIST_ERROR:
    case actionTypes.EDIT_TASK_LIST_LOADING:
    case actionTypes.EDIT_TASK_LIST_ERROR:
      if (!action.taskListId) {
        return state;
      }
      return state.set(
        action.taskListId.toString(),
        task_list(state.get(action.taskListId.toString(), undefined), action)
      );
    case actionTypes.ADD_TASK_LIST_SUCCESS:
      return mergeEntities(state, fromJS(action.response.entities.task_lists));
    case actionTypes.FETCH_TEAM_TASKS_SUCCESS: {
      const { response = {} } = action;
      const { result = {} } = response;
      const { related = {} } = result;
      const { TaskList = {} } = related;
      state = mergeEntities(state, fromJS(TaskList));
      return state;
    }
    case actionTypes.INSERT_TASK_LIST_SUCCESS: {
      state = mergeEntities(state, fromJS(action.response.entities.task_lists));
      action.response.result.order.map((taskListId) => {
        state = state.set(`${taskListId}`, task_list(state.get(`${taskListId}`), action));
      });
      return state;
    }
    case actionTypes.INSERT_TASK_LIST_FROM_EVENT_STREAM: {
      state = mergeEntities(state, fromJS(action.response.entities.task_lists));
      action.order.map((taskListId) => {
        state = state.set(`${taskListId}`, task_list(state.get(`${taskListId}`), action));
      });
      return state;
    }
    case actionTypes.DUPLICATE_TASK_LIST_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { task_lists = {} } = entities;
      const taskListId = result.single;
      const projectId = task_lists[taskListId].project_id;
      const position = task_lists[taskListId].position;

      state = mergeEntities(state, fromJS(task_lists));

      const taskListsToChangePostion = state.filter((task_list) => {
        return task_list.project_id === projectId && task_list.id !== taskListId && task_list.position >= position;
      });

      if (taskListsToChangePostion.size > 0) {
        taskListsToChangePostion.forEach((taskList, key) => {
          state = state.set(
            `${key}`,
            new TaskList({
              ...taskList.toObject(),
              position: taskList.position + 1,
            })
          );
        });
      }

      return state;
    }
    case actionTypes.ANGULAR_INITIALIZE_TASKS:
    case actionTypes.FETCH_TASK_LISTS_SUCCESS:
    case actionTypes.FETCH_ACTIVITY_LOGS_SUCCESS:
    case actionTypes.FETCH_TASK_DEPENDENCIES_SUGGESTIONS_SUCCESS:
    case actionTypes.LOAD_TASK:
    case actionTypes.COMPLETE_TASK_SUCCESS:
    case actionTypes.OPEN_TASK_SUCCESS:
    case actionTypes.MOVE_TASK_LIST_TO_PROJECT_SUCCESS:
      if (action.response && action.response.entities && action.response.entities.task_lists) {
        return mergeEntities(state, fromJS(action.response.entities.task_lists));
      }
      return state;
    case actionTypes.FETCH_TASK_LIST_SUCCESS:
    case actionTypes.EDIT_TASK_LIST_SUCCESS:
    case actionTypes.COMPLETE_TASK_LIST_SUCCESS:
      if (!action.taskListId) {
        return state;
      }
      return mergeEntities(state.remove(action.taskListId.toString()), fromJS(action.response.entities.task_lists));
    case actionTypes.MOVE_TASK_LIST_TO_TRASH_LOADING:
    case actionTypes.MOVE_TASK_LIST_TO_TRASH_SUCCESS:
    case actionTypes.MOVE_TASK_LIST_TO_TRASH_ERROR:
      if (!action.id || action.objectType !== `TaskList` || !state.get(action.id.toString())) {
        return state;
      }
      return state.set(action.id.toString(), task_list(state.get(action.id.toString(), undefined), action));
    case actionTypes.REOPEN_TASK_LIST_LOADING:
    case actionTypes.REOPEN_TASK_LIST_SUCCESS:
    case actionTypes.COMPLETE_TASK_LIST_LOADING:
    case actionTypes.COMPLETE_TASK_LIST_ERROR: {
      const { taskListId } = action;
      return state.set(`${taskListId}`, task_list(state.get(`${taskListId}`, undefined), action));
    }
    case actionTypes.ADD_TASK_SUCCESS:
    case actionTypes.CREATE_TASK_FROM_COMMENT_SUCCESS: {
      return mergeEntities(state, fromJS(action.response.entities.task_lists));
    }
    case actionTypes.REORDER_TASK_LIST_LOADING:
    case actionTypes.REORDER_TASK_LIST_SUCCESS: {
      action.taskListsOrder = action.taskListsOrder.filter((taskListId) => {
        const taskList = state.get(`${taskListId}`);
        return taskList && !taskList.get("is_completed");
      });
      action.taskListsOrder.map((taskListId) => {
        state = state.set(`${taskListId}`, task_list(state.get(`${taskListId}`), action));
      });
      return state;
    }
    case actionTypes.REORDER_TASK_LIST_ERROR:
      return state;
    case actionTypes.TASK_LIST_MOVE_TO_TRASH_FROM_EVENT_STREAM:
    case actionTypes.TASK_LIST_RESTORED_FROM_TRASH_FROM_EVENT_STREAM:
    case actionTypes.TASK_LIST_COMPLETED_FROM_EVENT_STREAM:
    case actionTypes.TASK_LIST_REOPENED_FROM_EVENT_STREAM:
    case actionTypes.ADD_TASK_LIST_FROM_EVENT_STREAM:
    case actionTypes.UPDATE_TASK_LIST_FROM_EVENT_STREAM:
    case actionTypes.TASK_LIST_MOVED_TO_PROJECT_FROM_EVENT_STREAM: {
      const { response = {} } = action;
      const { result: taskListId } = response;

      if (taskListId) {
        return state.set(`${taskListId}`, task_list(state.get(`${taskListId}`), action));
      }

      return state;
    }
    case actionTypes.TASK_LIST_REORDERED_FROM_EVENT_STREAM: {
      const { response = {} } = action;
      const { ordered_task_list_ids = [] } = response;

      const ids = ordered_task_list_ids.filter((taskListId) => {
        const taskList = state.get(`${taskListId}`);
        return taskList && !taskList.get("is_completed");
      });

      ids.forEach((id, key) => {
        state = state.set(
          `${id}`,
          task_list(state.get(`${id}`), {
            ...action,
            id,
            position: key + 1,
          })
        );
      });

      return state;
    }
    case actionTypes.ADD_PROJECT_FROM_DATASET_SUCCESS:
    case actionTypes.FETCH_USER_TASKS_SUCCESS:
    case actionTypes.PROJECT_TEMPLATE_APPLY_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { task_lists } = entities;

      if (task_lists) {
        return mergeEntities(state, fromJS(task_lists));
      }

      return state;
    }
    case actionTypes.PROJECT_MOVE_TO_TRASH_FROM_EVENT_STREAM_SUCCESS: {
      const keys = state.keySeq();

      keys.forEach((key) => {
        state = state.set(key, task_list(state.get(key), action));
      });

      return state;
    }
    case actionTypes.PROJECT_COMPLETED_FROM_EVENT_STREAM_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result: projectId = 0 } = response;
      const { projects = {} } = entities;
      const project = projects[projectId];
      if (project) {
        return state.reduce((prev, next) => {
          if (next.project_id === projectId) {
            const updated = next
              .set("is_completed", true)
              .set("completed_on", next.completed_on ? next.completed_on : project.completed_on)
              .set("completed_by_id", next.completed_by_id ? next.completed_by_id : project.completed_by_id);
            return prev.set(`${next.id}`, updated);
          }
          return prev;
        }, state);
      }

      return state;
    }
    case actionTypes.COMPLETE_TASK_FROM_EVENT_STREAM: {
      const { response = {} } = action;
      const { entities = {}, result = 0 } = response;
      const { tasks = {} } = entities;
      if (tasks[result]) {
        const id = tasks[result].task_list_id;
        const taskList = state.get(`${id}`);
        if (taskList) {
          let openTasks = taskList.get("open_tasks", 0);
          let completedTasks = taskList.get("completed_tasks", 0);
          openTasks = openTasks - 1;
          completedTasks = completedTasks + 1;
          if (openTasks < 0) openTasks = 0;

          const updated = taskList.set("open_tasks", openTasks).set("completed_tasks", completedTasks);
          return state.set(`${id}`, updated);
        }
      }
      return state;
    }
    case actionTypes.FETCH_TASKS_ARCHIVE_SUCCESS: {
      const filteredTaskLists = {};
      for (let index in action.response) {
        const item = action.response[index];
        if (item.class === "TaskList") {
          filteredTaskLists[item.id] = item;
        }
      }
      return mergeEntities(state, fromJS(filteredTaskLists));
    }
    case actionTypes.FLUSH_TASKS_ARCHIVE: {
      const projectId = action.payload.projectId;
      if (!projectId) {
        return state;
      }
      state.forEach((taskList) => {
        if (taskList.is_completed && !taskList.is_trashed && taskList.project_id === projectId) {
          state = state.delete(`${taskList.id}`);
        }
      });
      return state;
    }
    default:
      return state;
  }
};

export default task_lists;
